import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

/* ------------------------------
   フェードアニメーション
------------------------------ */

export const onRouteUpdate = () => {
  /* ------------------------------
   * フェード系
   * ------------------------------ */
  if ("IntersectionObserver" in window) {
    const elements = document.querySelectorAll(
      ".fadeInUp, .fadeInRight, .fadeInLeftToRight"
    )

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach(el => observer.observe(el))
  }
}
